import React from 'react'
import TranslateText from 'translation/TranslateText';

function FAQHeader() {
    return (
        <div className="page-header-container">
          <div
            className="page-header section-dark"
            style={{
              backgroundImage: `url(${require("assets/img/FAQ.jpg")})`,
              // backgroundPosition: "right -350px",
              backgroundSize: "cover"

            }}
          >
           <div className="centered">
          <h1 className='age inq'><TranslateText text="Tradeline FAQ's"/></h1>
        </div>
          </div>
        </div>
    );
}

export default FAQHeader


